export function formatINR(n) {
  const num = Number(n);
  if (!Number.isFinite(num)) return "₹0";
  return num.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0
  });
}
